/**
 * Duck-typed recursive filter — works on both class instances and plain
 * deserialized objects, safe across module boundaries.
 */
export function matchesObject(entry, uuid) {
    const batch = entry;
    if (Array.isArray(batch.children)) {
        return batch.children.some(c => matchesObject(c, uuid));
    }
    return entry.affectedUuids?.includes(uuid) ?? false;
}

/**
 * Returns true if the entry is associated with the given page UUID.
 * Checks entry.pageUuid directly; for batch commands checks children.
 */
export function matchesPage(entry, pageUuid) {
    const batch = entry;
    if (Array.isArray(batch.children)) {
        return batch.children.some(c => matchesPage(c, pageUuid));
    }
    return (entry.pageUuid ?? null) === pageUuid;
}
